var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-tabs',{attrs:{"background-color":"toolbarColor"}},[_c('v-tab',{attrs:{"to":"/stock/report/transfers"}},[_vm._v(" Stock Transfers Report ")])],1),_c('v-card-text',[_c('router-view')],1)],1),_c('snackbar',{ref:"snackbar"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }